export const HOT_GAPPERS_SYMBOL_NAME_LIMIT = 20;
export const HOT_GAPPERS_ROW_COUNT = 9;
export const HOT_GAPPERS_NEXT_BTN_ROW_COUNT = 5;
export const HOT_GAPPERS_FIRST_PART_SCROLL_POSITION = 738;
